import { render, staticRenderFns } from "./wxxiangqingCheck.vue?vue&type=template&id=f5734d7e&scoped=true"
import script from "./wxxiangqingCheck.vue?vue&type=script&lang=js"
export * from "./wxxiangqingCheck.vue?vue&type=script&lang=js"
import style0 from "./wxxiangqingCheck.vue?vue&type=style&index=0&id=f5734d7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5734d7e",
  null
  
)

export default component.exports